import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { AuthContainer, RegisterContainer } from '../app/shared/index';
import ForgotPasswordContainer from '../app/shared/forgotPassword/ForgotPasswordContainer';
import ResetPasswordContainer from '../app/shared/resetPassword/ResetPasswordContainer';
import ResetPasswordSuccess from '../app/shared/success/resetPasswordSuccess/ResetPasswordSuccess';
import InvalidTokenError from '../app/shared/error/invalidTokenError/InvalidTokenError';
import CampaignContainer from '../app/admin/campaign/CampaignContainer';
import BetaPostDetailContainer from '../app/admin/betaPost/BetaPostDetailContainer';
import { NotFoundContainer } from '../app/404';
import { routeConstants } from '../utils';
import RegisterSuccess from '../app/shared/register/RegisterSuccess';

export default function PublicRoutes({ match, ...props }) {
  const { location: { pathname } } = props;
  if (pathname === `${match.path}`
    || pathname.includes('login') || pathname === `${match.path}forgotPassword` || pathname === `${match.path}createGoal`
    || pathname === `${match.path}resetPassword` || pathname === `${match.path}resetPasswordSuccess`) {
    const userData = JSON.parse(localStorage.getItem('user'));
    if (userData) {
      const pathToRedirect = userData.role === 'systemAdmin' ? `${routeConstants.ADMIN_OFFER}` : `${routeConstants.DASHBOARD}`;
      return (
        <Redirect to={pathToRedirect} />
      );
    }
  }
  return (
    <div>
      <Switch>
        <Route
          path={`${match.path}`}
          exact
          component={AuthContainer}
        />
        <Route
          path={`${match.path}login/:token?`}
          exact
          component={AuthContainer}
        />
        <Route
          path={`${match.path}login`}
          exact
          component={AuthContainer}
        />
        <Route
          path={`${match.path}register`}
          exact
          component={RegisterContainer}
        />
        <Route
          path={`${match.path}forgotPassword`}
          exact
          component={ForgotPasswordContainer}
        />
        <Route
          exact
          path={`${match.path}resetPassword/:token`}
          component={ResetPasswordContainer}
        />
        <Route
          exact
          path={`${match.path}resetPasswordSuccess`}
          component={ResetPasswordSuccess}
        />
        <Route
          exact
          path={`${match.path}InvalidTokenError`}
          component={InvalidTokenError}
        />
        <Route
          path={`${match.path}admin/campaign/:offerId/:artistId`}
          exact
          component={CampaignContainer}
        />
        <Route
          path={`${match.path}betaPost/:betaPostId/userId/:userId`}
          exact
          component={BetaPostDetailContainer}
        />
        <Route
          path={`${match.path}registerSuccess`}
          exact
          component={RegisterSuccess}
        />
        <Route component={NotFoundContainer} />
      </Switch>
    </div>
  );
}

PublicRoutes.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }).isRequired,
};
